var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('div',_vm._b({class:_vm.icon},'div',_vm.$attrs,false)),_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.helpText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }